import React, { useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRocket, faXmark } from '@fortawesome/free-solid-svg-icons';
import './Navbar.css';

export default function NavBar() {
  /* -----------------------------------------------------------
     1. Sticky-navbar scroll-class
  ----------------------------------------------------------- */
  useEffect(() => {
    const nav = document.querySelector('.navbar');
    const onScroll = () =>
      nav.classList.toggle('navbar-scrolled', window.scrollY > 20);

    onScroll(); // initial state
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  /* -----------------------------------------------------------
     2. Body scroll-lock & auto-close helpers
  ----------------------------------------------------------- */
  useEffect(() => {
    const mainNav = document.getElementById('mainNav');

    /* toggle body class wanneer sidebar in/uit klapt */
    const toggleBody = () =>
      document.body.classList.toggle(
        'nav-open',
        mainNav.classList.contains('show')
      );

    /* sidebar dichtgooien */
    const closeSidebar = () => {
      mainNav.classList.remove('show');
      document.body.classList.remove('nav-open');
    };

    /* a) body-lock listeners */
    mainNav.addEventListener('shown.bs.collapse', toggleBody);
    mainNav.addEventListener('hidden.bs.collapse', toggleBody);

    /* b) auto-close bij klik op link of CTA */
    const links = mainNav.querySelectorAll('.nav-link, .btn');
    links.forEach((l) => l.addEventListener('click', closeSidebar));

    /* clean-up */
    return () => {
      mainNav.removeEventListener('shown.bs.collapse', toggleBody);
      mainNav.removeEventListener('hidden.bs.collapse', toggleBody);
      links.forEach((l) => l.removeEventListener('click', closeSidebar));
    };
  }, []);

  /* -----------------------------------------------------------
     3. Render
  ----------------------------------------------------------- */
  return (
    <nav
      className="navbar navbar-expand-lg"
      role="navigation"
      aria-label="Hoofd navigatie"
    >
      <div className="container">
        {/* Logo ------------------------------------------------ */}
        <Link to="/" className="navbar-brand d-flex align-items-center gap-2">
          <FontAwesomeIcon icon={faRocket} className="logo-icon text-orange" />
          <span className="logo-title">
            Online<span className="text-orange">Growth</span>Club
          </span>
        </Link>

        {/* Hamburger (open) ----------------------------------- */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mainNav"
          aria-controls="mainNav"
          aria-expanded="false"
          aria-label="Menu openen"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Sidebar / collapse ---------------------------------- */}
        <div className="collapse navbar-collapse" id="mainNav">
          {/* Close-button (alleen mobiel) */}
          <button
            type="button"
            className="close-sidebar d-lg-none"
            aria-label="Menu sluiten"
            data-bs-toggle="collapse"
            data-bs-target="#mainNav"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>

          {/* Navigatie links */}
          <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-2">
            <li className="nav-item">
              <NavLink to="/" className="nav-link" end>
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/over-ons" className="nav-link">
                Over ons
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/diensten" className="nav-link">
                Onze diensten
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/portfolio" className="nav-link">
                Portfolio
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/contact" className="nav-link">
                Contact
              </NavLink>
            </li>
            {/* <li className="nav-item">
              <NavLink to="/blog" className="nav-link">
                Blog
              </NavLink>
            </li> */}
            <li className="nav-item mt-2 mt-lg-0">
              <NavLink to="/contact" className="btn btn-orange">
                GROEISCAN
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
